import { Compass } from 'lucide-react';
import { useLocation } from 'react-router';
import { ButtonLink, EmptyState } from '@/components';
import { paths } from '@/routing';

export default function NotFound() {
  const location = useLocation();
  return (
    <EmptyState
      icon={<Compass />}
      title="Page not found"
      description={
        <>
          Nothing lives at <code>{location.pathname}</code>.
        </>
      }
      action={<ButtonLink to={paths.home()}>Back to projects</ButtonLink>}
    />
  );
}
